import { defineIntegration, consoleSandbox } from '@sentry/core';

const spanStreamingIntegrationShim = defineIntegration(() => {
  consoleSandbox(() => {
    console.warn("You are using spanStreamingIntegration() even though this bundle does not include tracing.");
  });
  return {
    name: "SpanStreaming"
  };
});

export { spanStreamingIntegrationShim };
//# sourceMappingURL=SpanStreaming.js.map
